import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStatusBarStyles = makeStyles(({ typography, spacing, palette }) =>
  createStyles({
    errorDiv: { padding: spacing(2) },
    fullSize: { height: '100%', width: '100%' },
    wrapper: {
      width: '80%',
      marginLeft: '10%',
      position: 'absolute',
      bottom: 5,
      zIndex: 450,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    statusBarMenu: { borderRight: `${palette.grey[600]} 2px solid` },
    statusBar: {
      backgroundColor: palette.mode === 'dark' ? palette.grey[100] : palette.common.white,
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      borderRadius: 4,
    },
    menuSection: {
      textAlign: 'center',
      alignSelf: 'center',
      fontFamily: typography.fontFamily,
      cursor: 'pointer',
      paddingLeft: spacing(2),
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyItems: 'center',
    },
    section: {
      textAlign: 'center',
      alignSelf: 'center',
      fontFamily: typography.fontFamily,
      cursor: 'pointer',
      minWidth: 120,
      padding: `${spacing(1.5)} ${spacing(2)}`,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyItems: 'center',
      '&$firstStatus': { padding: `0 ${spacing(2)} 0 ${spacing(3)}` },
    },
    colorBar: {
      margin: `${spacing(1)} 0`,
      height: 5,
      minWidth: spacing(3),
      width: '100%',
    },
    name: {
      fontSize: 10,
      whiteSpace: 'nowrap',
    },
    icon: {
      marginRight: 5,
    },
  })
);

export default useStatusBarStyles;
